import Service from '@ember/service';
import clarity from '@microsoft/clarity';
import config from 'walden-fast/config/environment';

export type ConsentStatus = 'granted' | 'denied';

export interface ClarityConsent {
  ad_Storage: ConsentStatus;
  analytics_Storage: ConsentStatus;
}
export default class ClarityService extends Service {
  private initialized = false;
  private enabled = config.clarity.isEnabled;

  start(): void {
    if (!this.enabled) {
      return;
    }

    if (!this.initialized && config.clarity.projectId) {
      clarity.init(config.clarity.projectId);
      this.initialized = true;
      try {
        const clarityWindow = window as unknown as {
          clarity: (command: string, data: ClarityConsent) => void;
        };
        clarityWindow.clarity('consentv2', {
          ad_Storage: 'granted',
          analytics_Storage: 'granted',
        });

        // eslint-disable-next-line no-console
        console.info('[Clarity] Consent updated');
      } catch (error) {
        console.error('[Clarity] Failed to set consent:', error);
      }
    } else {
      console.warn('[Clarity] Missing project ID or already initialized.');
    }
  }

  trackEvent(eventName: string): void {
    if (this.enabled && this.initialized) {
      clarity.event(eventName);
    }
  }

  identifyUser(customId: string): void {
    if (this.enabled && this.initialized) {
      clarity.identify(customId);
    }
  }

  trackPage(): void {
    if (this.enabled && this.initialized) {
      clarity.setTag('page', window.location.pathname);
    }
  }
}

// Don't remove this declaration: this is what enables TypeScript to resolve
// this service using `Owner.lookup('service:chat')`, as well
// as to check when you pass the service name as an argument to the decorator,
// like `@service('chat') declare altName: ChatService;`.
declare module '@ember/service' {
  interface Registry {
    clarity: ClarityService;
  }
}
